export const Limanu = require("./Limanu.png") 
